import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { _post, _Alert } from './Function';
import Loading from './Loading';
import '../css/Register.css';

class RegisterForm extends Component {
    constructor(props) {
        super(props);
        this.state={ page: this.props.Page, member: '', id_card: '', mobile: '', loadingShow: false };
    }

    update = (t, e) => {
        this.setState({ [t]: e.target.value });
    }

    Check = () => {
        if ( this.state.member === '' ) {
            _Alert('กรุณากรอกเลขที่สมาชิก');
            return;
        }
        const idCard = this.state.id_card.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
        if ( this.state.id_card === '' || idCard.length !== 13 ) {
            _Alert('กรุณากรอกรหัสบัตรประชาชน 13 หลัก');
            return;
        } 
        const mobile = this.state.mobile.replace(' ', '').replace(' ', '');
        if ( this.state.mobile === '' || mobile.length !== 10 ) {
            _Alert('กรุณากรอกเบอร์โทรศัพท์มือถือ 10 หลัก');
            return;
        }   

        var member = '';
        if ( this.state.member.length === 1 ) {
            member = '00000' + this.state.member;
        } else if ( this.state.member.length === 2 ) {
            member = '0000' + this.state.member;
        } else if ( this.state.member.length === 3 ) {
            member = '000' + this.state.member;
        } else if ( this.state.member.length === 4 ) {
            member = '00' + this.state.member;
        } else if ( this.state.member.length === 5 ) {
            member = '0' + this.state.member;
        } else {
            member = this.state.member;
        }

        this.Submit(member, idCard, mobile)
    }

    Submit(member, idCard, mobile) {
        this.setState({ loadingShow: true });
        var param = { member_id: member, idCard: idCard, mobile: mobile, via: 'website' };
        _post('register.account.php', param).then(res => { 
            this.setState({ loadingShow: false });
            if ( res.data.status ) {
                this.props.onSelectPage(2);
                this.props.onTimeOut(res.data.timeOut);
                this.props.onAccountID(res.data.account_id)
            } else {
                _Alert('modify', 'error', 'พบข้อผิดพลาด', res.data.responseText);
            }
        }).catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });
    }

    render() {
        return (
            <div>
                <Loading show={this.state.loadingShow} />
                <div className="register-title">กรุณาป้อนข้อมูลของท่านที่ได้ลงทะเบียนไว้กับสหกรณ์</div>
                <div className="input-group mb-3 txt-input registerForm">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1"><i className="fas fa-user user"></i></span>
                    </div>
                    <InputMask className="form-control input-user" mask="999999" maskChar={null} placeholder="เลขที่สมาชิก" value={this.state.member} onChange={(e) => this.update("member", e)} />
                </div>
                <div className="input-group mb-3 txt-input registerForm">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1"><i className="fas fa-id-card id-card"></i></span>
                    </div>
                    <InputMask className="form-control input-user" mask="9-9999-99999-99-9" maskChar={null} placeholder="รหัสบัตรประชาชน" value={this.state.id_card} onChange={(e) => this.update("id_card", e)} />
                </div>
                <div className="input-group mb-3 txt-input registerForm">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1"><i className="fas fa-phone-volume phone"></i></span>
                    </div>
                    <InputMask className="form-control input-user" mask="99 9999 9999" maskChar={null} placeholder="เบอร์โทร" value={this.state.mobile} onChange={(e) => this.update("mobile", e)} />
                </div>
                <div className="register-row">
                    <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.Check()}>ลงทะเบียน</button>
                </div> 
            </div>
        )
    }
}

export default RegisterForm;
